import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { fadeUp, stagger, viewport } from "../../lib/motion";
import { consumerFeatures } from "../../lib/recursos";

export const Recursos = () => (
  <section id="recursos" className="bg-white py-24 md:py-32" data-testid="recursos-section">
    <div className="mx-auto max-w-8xl px-5 md:px-10">
      <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-amber">
            Recursos do app
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-maraca-navy md:text-5xl lg:text-6xl">
            Tudo para pedir com facilidade
          </h2>
          <p className="mt-4 text-lg text-maraca-navy/70">
            Um aplicativo completo, rápido e prático — feito para tornar sua experiência muito mais simples.
          </p>
        </div>
        <Link
          to="/recursos"
          data-testid="ver-recursos-link"
          className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-maraca-navy px-6 py-3 font-display text-base font-bold text-white transition-transform duration-300 hover:-translate-y-1"
        >
          Ver todos os recursos
          <ArrowRight size={18} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
      >
        {consumerFeatures.map((f) => (
          <motion.div
            key={f.title}
            variants={fadeUp}
            data-testid={`recurso-${f.title.toLowerCase().replace(/\s/g, "-")}`}
            className="group flex items-start gap-4 rounded-2xl border border-black/5 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-maraca-teal/10 transition-transform duration-300 group-hover:scale-110">
              <f.icon size={26} weight="duotone" className="text-maraca-teal" />
            </span>
            <div>
              <h3 className="font-display text-lg font-bold text-maraca-navy">{f.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-maraca-navy/70">{f.desc}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
